import * as React from 'react'
import { useQuery } from 'react-query'
import getAllBuilderGreetingCardDesigns from '../queries/getBuilderGreetingCardDesigns'

const useGetGreetingCardDesigns = () => {
    const { data, error, isLoading, isSuccess, isError } = useQuery(
        'getBuilderGreetingCardCategories',
        getAllBuilderGreetingCardDesigns,
        {
            onError: (error: any) => {
                // error.name = ?
                // Sentry.captureException(error, {
                //     contexts: {
                //         data: {
                //             errorMessage: "Error",
                //         },
                //     },
                //     user: {
                //         id: JSON.stringify(Cookies.get('GCG_CLIENT_USER_ID')),
                //     },
                // })
            },
            // @ts-ignore
            refetchOnWindowFocus: false,
        }
    )

    return { data, error, isLoading, isSuccess, isError }
}

export default useGetGreetingCardDesigns
